import React from 'react';
import classNames from 'classnames';

import {
  CHARGE_HEADING,
  CHARGE_SHORT_LEAD,
  chargeCardStepLines,
  chargeShortRest,
} from '../../util/chargeCopy';

import css from './ChargeReassurance.module.css';

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false">
    <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.16" />
    <path
      d="M6 10.4 8.6 13 14 7.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Calm "no charge until after a session" block.
 *
 * - `full`: heading + 4 lines (add-card step, above the card form).
 * - `short`: one bold line + a short second sentence (booking panel, checkout,
 *   save-card gate), placed right above the final button / near the card.
 *
 * @param {Object} props
 * @param {'full'|'short'} [props.variant]
 * @param {boolean} [props.startNow] Talk Now wording for `short`.
 * @param {boolean} [props.card] Card-entry wording for `short`.
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const ChargeReassurance = props => {
  const { variant = 'short', startNow = false, card = false, className } = props;
  if (variant === 'full') {
    return (
      <section
        className={classNames(css.root, css.full, className)}
        data-charge-reassurance="full"
        aria-labelledby="charge-reassurance-heading"
      >
        <h2 className={css.heading} id="charge-reassurance-heading">
          {CHARGE_HEADING}
        </h2>
        <ul className={css.list}>
          {chargeCardStepLines().map(line => (
            <li key={line} className={css.item}>
              <span className={css.icon}>
                <CheckIcon />
              </span>
              <span>{line}</span>
            </li>
          ))}
        </ul>
      </section>
    );
  }
  return (
    <p
      className={classNames(css.root, css.short, className)}
      data-charge-reassurance="short"
      data-start-now={startNow ? 'true' : 'false'}
    >
      <span className={css.icon}>
        <CheckIcon />
      </span>
      <span>
        <strong className={css.lead}>{CHARGE_SHORT_LEAD}</strong>{' '}
        <span className={css.rest}>{chargeShortRest({ startNow, card })}</span>
      </span>
    </p>
  );
};

export default ChargeReassurance;
